import { render } from "./SignupStepReceipt.vue?vue&type=template&id=12517fda"
import script from "./SignupStepReceipt.vue?vue&type=script&lang=js"
export * from "./SignupStepReceipt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__